const normalizeAccountType = (value?: string | null): string =>
  (value || '').toLowerCase().replace(/[^a-z0-9]/g, '');

const QUICKBOOKS_INVALID_BILL_DETAIL_TYPES = new Set([
  'accountspayable',
  'accountsreceivable',
]);

/**
 * Return whether an ERP account may be offered for a bill-detail/category line.
 * Unknown types remain visible so older or provider-specific account catalogs do
 * not become unusable; submission-time backend validation remains authoritative.
 */
export const isBillDetailAccountAllowed = (
  erpType: string | null | undefined,
  accountType: string | null | undefined,
): boolean => {
  const normalizedType = normalizeAccountType(accountType);
  if (!normalizedType) {
    return true;
  }

  const normalizedProvider = (erpType || '').toLowerCase();
  if (normalizedProvider === 'quickbooks' || normalizedProvider === 'quickbooks_desktop') {
    return !QUICKBOOKS_INVALID_BILL_DETAIL_TYPES.has(normalizedType);
  }

  return true;
};
